import Bugsnag from '@bugsnag/js'

type WebGLContextLossReport = {
  context: string
  errorName: string
  metadataSection: string
  metadata: Record<string, unknown>
}

export const reportWebGLContextLost = ({ context, errorName, metadataSection, metadata }: WebGLContextLossReport) => {
  if (!Bugsnag.isStarted()) return

  const error = new Error(`${context} WebGL context lost`)
  error.name = errorName
  Bugsnag.notify(error, event => {
    event.context = context
    event.severity = 'warning'
    event.addMetadata(metadataSection, {
      ...metadata,
      viewportHeight: window.innerHeight,
      viewportWidth: window.innerWidth,
      maxTouchPoints: window.navigator.maxTouchPoints,
    })
  })
}
